import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import PerDiemForm from '../../perdiemLodging/page/perdiemLodging.mjs';
import PageShell from '../../components/PageShell.mjs';
import { AuthContext } from '../../authProvider.mjs';
import ClaimQuestionsBanner from '../../clarifications/components/ClaimQuestionsBanner.mjs';


// This route's page frame. Given adminMode, PerDiemForm renders its content
// without a frame of its own, so this band title is the only one on the page.
// Auditors open claims read-only through this same route (auditor dashboard,
// monthly report), and the form puts them out of admin mode, so their band
// reads "Per Diem Claim" - the same rule as the unwrapped
// /admin/claim/perdiem-lodging route and the expense form's admin route.
const AdminPerDiemEdit = () => {
  const { isAuditor } = useContext(AuthContext);
  const { claimId } = useParams();
  return (
    <PageShell title={isAuditor ? 'Per Diem Claim' : 'Admin Edit: Per Diem Claim'} width="7xl" photo={false}>
      {/* Open clarification questions on the claim - where the reviewers' links land. */}
      <ClaimQuestionsBanner claimType="PerDiemClaim" claimId={claimId} />
      <PerDiemForm adminMode={true} />
    </PageShell>
  );
};

export default AdminPerDiemEdit;
